module.exports = __webpack_public_path__ + "assets/img/radar-c02fe17a.png";